import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import { TimelineItemState } from 'components/generics/Timeline/index';
import {
  getStyleTimelineItem,
  TimelineItemStyleOptions,
} from 'components/generics/Timeline/utils/style';
import { HTMLAttributes } from 'react';
import Skeleton from 'react-loading-skeleton';
import classes from './index.module.scss';

export interface TimeLineItemTextOptions {
  passedTitleClassName?: string;
  passedSubtitleClassName?: string;
  currentTitleClassName?: string;
  currentSubtitleClassName?: string;
  nextTitleClassName?: string;
  nextSubtitleClassName?: string;
}

export interface TimeLineItemTextType
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  state: TimelineItemState;
  isFirst: boolean;
  isLast: boolean;
  title: string;
  titleLoading?: boolean;
  subtitle?: string;
  subtitleLoading?: boolean;
  titleClassName?: string;
  subtitleClassName?: string;
  textOptions: TimeLineItemTextOptions;
  options?: Partial<TimelineItemStyleOptions>;
}

const TimelineItemText = ({
  state,
  isFirst,
  isLast,
  title,
  titleLoading,
  subtitle,
  subtitleLoading,
  titleClassName,
  subtitleClassName,
  className,
  options,
}: TimeLineItemTextType) => {
  const {
    titleClassName: innerTitleClassName,
    subtitleClassName: innerSubtitleClassName,
  } = getStyleTimelineItem(state, isFirst, isLast, options);

  return (
    <div className={className}>
      {!titleLoading ? (
        <Typography
          className={classNames(
            classes.title,
            titleClassName,
            innerTitleClassName
          )}
        >
          {title}
        </Typography>
      ) : (
        <Skeleton
          width={100}
          height={15}
        />
      )}
      {subtitleLoading && subtitleLoading && (
        <Skeleton
          width={200}
          height={15}
        />
      )}
      {subtitle && !subtitleLoading && (
        <Typography
          className={classNames(
            classes.subtitle,
            subtitleClassName,
            innerSubtitleClassName
          )}
        >
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default TimelineItemText;
